import React from 'react';
import { get, size } from 'lodash';
import { object, func } from 'prop-types';
import { Button, Row } from '../../../../common';
import { genUUID } from '../../../../../utils/misc';

const AddQuestionButton = ({ values, setFieldValue }) => {
    const addQuestion = () => {
        const questions = get(values, 'questions', []);
        const newQuestion = { idTypeQuestion: 1, idQuestion: genUUID(), question: `Pregunta ${size(questions) + 1}` };
        questions.splice(size(questions), 0, newQuestion);
        setFieldValue('questions', questions);
    };

    return <Row justify='flex-end' mT={10} mB={10}>
        <Button onClick={addQuestion} width={250}>
            Agregar pregunta
        </Button>
    </Row>;
};

AddQuestionButton.propTypes = {
    values: object,
    setFieldValue: func
};

export default AddQuestionButton;
